import React, { PureComponent, Fragment } from 'react';

class CheckAccess extends PureComponent {
  static defaultProps = {
    allowedValues: [],
    value: ""
  }
  
  render() {
    const { allowedValues, value, children } = this.props;
    
    return (
      <Fragment>
        {
          allowedValues.includes(value) &&
          children
        }
      </Fragment>
    )
  }
}

export default CheckAccess;


// WEBPACK FOOTER //
// src/components/checkAccess/CheckAccess.js